import { Icon } from '@adobe/react-spectrum';

const MilestoneIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.6895 2.67773C17.4946 2.53711 17.2432 2.49707 17.0151 2.57324L16.4277 2.76758C15.332 3.07324 14.1777 3.05274 13.0913 2.70117L10.3638 1.82129C9.1543 1.43164 7.86035 1.36231 6.62305 1.62598L4.5 2.0752V1.75C4.5 1.33594 4.16406 1 3.75 1C3.33594 1 3 1.33594 3 1.75V18.25C3 18.6641 3.33594 19 3.75 19C4.16406 19 4.5 18.6641 4.5 18.25V13.6328L6.93311 13.1172C7.91651 12.9111 8.94336 12.9629 9.90284 13.2734L12.6309 14.1543C13.3565 14.3877 14.1055 14.5059 14.8594 14.5059C15.5283 14.5059 16.2017 14.4131 16.8652 14.2256L17.4849 14.0215C17.792 13.9209 18 13.6338 18 13.3096V3.28516C18 3.04493 17.8848 2.81835 17.6895 2.67773ZM16.5 12.7676L16.4273 12.792C15.3335 13.1006 14.1792 13.0771 13.0913 12.7266L10.3638 11.8457C9.15577 11.456 7.8628 11.3896 6.62306 11.6504L4.50001 12.1001V3.60767L6.9336 3.09278C7.91553 2.88477 8.94337 2.93946 9.90284 3.24903L12.6304 4.12891C13.8799 4.53321 15.2022 4.59082 16.5 4.29493V12.7676Z"
          fill="#222222"
        />
      </svg>
    </Icon>
  );
};

export default MilestoneIcon;
